<template>

<DialogBox :settings="settings" :disabled="Boolean(validationErrors)" @save="save" @show="dialogShown">
    <div class="pa-3 full-width" style="display:flex;">
        <div style="flex-basis:200px">
            <v-icon style="font-size:180px;color:#ddd">mdi-face-agent</v-icon>
        </div>
        <div style="flex-grow:1">
            <DateTime v-model="charge.date" date-only past class="mb-4"/>
            <v-combobox :return-object="false" v-model="charge.description" @change="updatePrice" :items="chargeDescriptions" label="Description" hide-details/>
            <CurrencyBox v-model="charge.amount" class="mt-2" label="Amount"/>
            <!-- <UserChooser v-model="charge.to" class="mb-3" label="Broker" @select="setBrokerName"/> -->
            <UserChooser v-model="charge.to" class="mb-3" label="Broker" />
            <UserChooser v-model="charge.from" class="mb-3" label="Processor"/>
            <v-text-field v-model="charge.clients" label="Clients" />
            <div class="small-text light-text">Broker Name: {{charge.brokerName}}</div>
        </div>
    </div>
    <template slot="footer">
        <v-tooltip v-if="validationErrors" right>
          <template v-slot:activator="{ on }">
            <v-icon color="red"  v-on="on">errors</v-icon>
          </template>
          <span>{{validationErrors}}</span>
        </v-tooltip>

    </template>
</DialogBox>

</template>

<script>
import DateHelpers from '../helpers/DateHelpers'
import DialogBox from '../ui-elements/DialogBox'
import DateTime from '../ui-elements/DateTime'
import CurrencyBox from '../ui-elements/CurrencyBox'
import UserChooser from '../ui-elements/UserChooser'
import StringHelpers from '../helpers/StringHelpers'
import NiceData from '../data/NiceData'
import DataHelpers from '../helpers/DataHelpers'
import AlertHelpers from '../helpers/AlertHelpers'
import ContactHelpers from '../helpers/ContactHelpers'
import TagStatusHelpers from '../helpers/TagStatusHelpers'
import BillingHelpers from '../helpers/BillingHelpers'

export default {
props:{
    settings: Object,
    charge: Object,
},
components:{
    DialogBox,
    DateTime,
    UserChooser,
    CurrencyBox,
},
data() {
    return {
        charges: [
            {text: 'Settlement (normal)', amount: 290},
            {text: 'Settlement (construct)', amount: 390},
            {text: 'Increase', amount: 110},
            {text: 'Admin Support', amount: 50},
            {text: 'Submission (normal)', amount: 200},
            {text: 'Submission (data)', amount: 120},
            {text: 'Submission (lodgement)', amount: 80},
            {text: 'Processing to Approval', amount: 175},
            {text: 'Approval to Settlement', amount: 160},
            {text: 'Complex Submission Loading (1)', amount: 75},
            {text: 'Complex Submission Loading (2)', amount: 160},
            {text: 'Urgent Submission', amount: 60},
            {text: 'Cloned Submission', amount: 100},
            {text: 'Withdrawn (short)', amount: 50},
            {text: 'Withdrawn (long)', amount: 75},
        ]

    }
},
computed: {
    chargeDescriptions() {
        return this.charges.map(o => {
            return {
                text: o.text + ' ' + StringHelpers.formatCurrency(o.amount),
                value: o.text
            }
        })
    },

    transaction() {
        return this.$store.getters.transaction
    },


    validationErrors() {
        try{

            let errors = ''
            if(!this.charge.description || this.charge.description.length < 5) {
                errors += 'Enter a proper description. '
            }
            if(!this.charge.clients || this.charge.clients.length < 5) {
                errors += 'Enter clients details. '
            }
            if(!this.charge.date) {
                errors += 'Enter a date. '
            }
            if(!this.charge.amount) {
                errors += 'Choose a valid charge amount. '
            }
            if(!(this.charge.from.user) && !(this.charge.from.uid)) {
                errors += 'The charge is not from a valid user. '
            }
            return errors
        } catch (e) {
            console.log('errors building charge validation string', e)
        }
    }


},
methods: {
    setBrokerName() {
        this.$set(this.charge, 'brokerName', ContactHelpers.fullName(this.charge.to))
    },

    updatePrice(newVal) {
        if(!newVal)
            return

        let chargeType = this.charges.find(o => o.text == newVal)
        if(chargeType)
            this.charge.amount = chargeType.amount
        else
            this.charge.amount = this.charges[0].amount
    },

    save() {
        BillingHelpers.saveCharge(this.charge)
        const fromFullName = ContactHelpers.fullName(this.charge.from)
        const auDate = DateHelpers.backwardsToAu(this.charge.date)

        const summary = `Charged ${StringHelpers.formatCurrency(this.charge.amount)} from ${fromFullName} on ${auDate}`
        this.charge.description = ''
        this.charge.amount = 0
        this.charge.clients = ''
        AlertHelpers.showAlert(summary)
        this.$emit('saved', summary)
    },

    dialogShown() {
        console.log('setting broker name....')
        this.setBrokerName()
    }


},

created() {

}

}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// ChargeDialog.vue?d007a572